import Logger from "./logger";

export default class XcontactListener {
    static Events = [
        'connect',
        'error',
        'disconnect',
        'reconnect',
        'reconnect_attempt',
        'reconnecting',
        'reconnect_error',
        'reconnect_failed',
        'connect_error',
        'connect_timeout',
        'connecting',
        'newMessage',
        'sendSuccess',
        'getAtendimentos',
        'deleteAtendimento',
        'authenticated',
        'getMeusAtendimentos',
        'message',
        'uploadStatus',
        'Tocando',
        'Hangup',
        'Atendeu',
        'RemoveAtendimento',
        'deslogarAgente',
        'errorMsg',
        'AddAtendimento'
    ];
    constructor(io, emitter, user) {
        this.emitter = emitter;
        this.socket = io;
        this.register();
        this.emitter = emitter;
        this.user = user;
    }

    /**
     * Listening all UA events
     */
    register() {
        XcontactListener.Events.forEach(event => this.socket.on(event, args => this.onEvent(event, args)))
    }

    /**
     * Broadcast all events to vuejs environment
     */

    onEvent(event, args) {
        let eventsByName = ['newMessage', 'Tocando', 'Hangup', 'Atendeu', 'RemoveAtendimento', `errorMsg`, 'AddAtendimento', 'getTemplatesZenvia'];
        try {
            Logger.info(event);
            if (!this.user.fullname) {
                this.user = JSON.parse(localStorage.getItem(`user`))


            }
            if (eventsByName.indexOf(event) !== -1) {
                if (args.atendimento) {
                    if (args.atendimento.ultimoAgente === this.user.fullname) this.emitter.emit(event, args);
                } else {
                    if (args.ultimoAgente) {
                        if (args.ultimoAgente === this.user.fullname) this.emitter.emit(event, args);
                    } else
                        if (args.agente) {
                            if (args.agente === this.user.fullname) this.emitter.emit(event, args);
                        } else {
                            if (args.fullname === this.user.fullname) this.emitter.emit(event, args);
                        }
                }
            } else if (event === "message") {
                let data = JSON.parse(args);
                if (data.event) this.emitter.emit(data.event, data);
                if (data.action) this.emitter.emit(data.action, data)
            } else {
                this.emitter.emit(event, args);
            }
        } catch (error) {
            console.error(error);
        }


    }
}